if (document.querySelectorAll(".scrolling-headline-area").length) {
    window.addEventListener("load", () => {
        const headlines = document.querySelectorAll(".scrolling-headline-area > .block__scrollContainer > .h2__scroll");
        let headerHeight;
        let maxOffsets = [];
        let vertOffset;
        let inViews;
        let scrollSpeedModifier = 0.50; // Modify this value to control the speed
        setup();

        window.addEventListener("scroll", () => {
            if (window.innerWidth < 768) { return; }
            let topBoundingRects = Array.from(headlines).map(headline => { return headline.getBoundingClientRect().top - vertOffset; });
            let bottomBoundingRects = Array.from(headlines).map(headline => { return headline.getBoundingClientRect().bottom; });
            for (let i = 0; i < headlines.length; i++) {
                let offScreenAbove = bottomBoundingRects[i] < 0;
                let offScreenBelow = topBoundingRects[i] > window.innerHeight;
                inViews[i] = !offScreenAbove && !offScreenBelow;
                if (inViews[i]) {
                    let heightDecimal = 1 - ((topBoundingRects[i])/window.innerHeight);
                    let offset = (maxOffsets[i] * heightDecimal + 100) * scrollSpeedModifier;
                    headlines[i].style.left = `${offset}%`;
                }
            }
        }, { passive: true });

        window.addEventListener("resize", setup);

        function setup() {
            headerHeight = parseFloat(getComputedStyle(document.querySelector(".scrolling-headline-area > .block__scrollContainer > .h2__scroll")).height);
            maxOffsets = [];
            for(let i = 0; i < headlines.length; i++) {
                headlines[i].style.left = `100%`;
            }
            for(let i = 0;i < headlines.length; i++) {
                let offsetPercentage = Math.ceil((headlines[i].scrollWidth/window.innerWidth) * 100) * -1;
                maxOffsets.push(offsetPercentage - 100);
            }
            vertOffset = headerHeight / 2;
            inViews = Array(headlines.length).fill(null);
        }
    });
}